import React from 'react';
import PropTypes from 'prop-types';

import { CKEditor } from "@ckeditor/ckeditor5-react";
import "@mhelli-proj/ckeditor5-custom-build/build/translations/en";
import ClassicEditor from "@mhelli-proj/ckeditor5-custom-build-v2";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-image/theme/image.css';
import './editor.css';
import * as Cookies from 'js-cookie';
import { toolbar, image, fontFamilies, styles } from './data';
import { host_v2 } from '../../utilities/requests';

const rtldir = '<p class="ckeditor-rtlDir"><span value=""> </span><p/>';
const ltrdir = '<p class="ckeditor-ltrDir"><span value=""> .</span><p/>';

function uploadAdapter(loader) {

  return {
    upload: () => {
      return new Promise(async (resolve, reject) => {
        const file = await loader.file;

        const imageBase64 = await handleImageUpload(file);

        const Data = {
          imageBase64
        };

        try {
          const response = await fetch(host_v2 + '/api/MediaApi/SaveImageInBucket', {
            method: "POST",
            body: JSON.stringify(Data),
            headers: {
              "Authorization": Cookies.getJSON('mhelli-token').accessToken,
              "Content-Type": "application/json"
            }
          });

          const data = await response.json();
          console.log(data)
          if (data.errorId !== 0) reject('عکس آپلود نشد')
          resolve({
            default: data?.result
          });

        } catch (er) {
          reject('not upload')
        }
      });
    },
    abort: () => { }
  };
}

function uploadPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return uploadAdapter(loader);
  };
}


async function handleImageUpload(files) {

  return await new Promise((resolve, reject) => {

    const reader = new FileReader();

    reader.readAsDataURL(files);
    reader.onloadend = () => {
      const base64String = reader.result;
      if (base64String)
        resolve(base64String);
      else reject(null)
    };
  })


};

export const component = class Clients extends React.PureComponent {
  static contextTypes = {
    store: PropTypes.object,
    user: PropTypes.object,
    content: PropTypes.string,
    handleChange: PropTypes.func
  }

  state = {
    html: this.props.content|| '',
    ref: React.createRef()
  }

  setHtmlToCkeditor(e) {
    this.setState(htm => ({ html: `${htm.html}${e}` }))
   
  }
  
  componentDidMount(){
    const tinymc = this.props.content?.indexOf('data-mathml="');

    if(tinymc > 0){
        alert('این سوال با tinymc ویرایش شده است')
    }

    const normalData = this.props.content?.replace(/data-mathml="/g, 'xmlns="');

    this.setState(e=>({...e, html: normalData }));
  }

   

  render() {
    return <span class="content content-preview">

      <div className='ckeditor-extra-tools'>

        <div className='ckeditor-tool-styles'>
          {/* <img className='ckeditor-tool-styles-icon' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABUklEQVR4nMWVv0oDQRCHP5UUGvUaCxs72xTBJ9DCxiK1rYLa2kQfQEQRxCYPIOkCprBOOm18AhXS2ZlCLP3DysAEljC3ZvcO/cHA3W+G/biZ3T34By0AB8BZThRSBjwDLhCiJeACmCZSx78s7jyAPN8AczGA60iAAx6A5UkB7QSAA16AelmADJgF3sf8N2CzDMC21kpb1saiVgbgFdhK2UGTApyGtGhgxGUs4EO3Y9/z+up9GvXtGMAXsK65Q8+XZ9EG8F0EcKf+KtDz/J56ovsigCv194xWiIfWJAFugQowBXQNQFdzFa2NBjTUq+ugreGPTm8jBSBbbkX9cwMgHlozSJ1BR/1dA7CjuU6RIT9qn6tAy/Nbek1L7ikGYF3XJ8CMcQ7EOzXqZY1cHQWuhaH3PjRu01E0Q4DM+GQXEdLSxRBANA/sB376eSEHT2b1t/oBs7AJ+h82s5wAAAAASUVORK5CYII=" /> */}

          <div className='ckeditor-tool-styles-items' >
            {styles.map(el =>
              <span onClick={() => this.setHtmlToCkeditor(el.value)} key={el.id} >
                {el.title}
              </span>
            )}
          </div>
        </div>

      </div>
      
      <CKEditor
        editor={ClassicEditor}
        data={this.state.html}
        ref={this.state.ref}
        id="ckeditor"
        config={{
          
          htmlSupport: {
            allow: [
              {
                name: /.*/,
                attributes: true,
                classes: true,
                styles: true
              }
            ]
          },
          extraPlugins: [uploadPlugin],
          // plugins: [window.MathJax ],
          language: 'fa',
          image,
          toolbar,
          fontSize: {

            options: fontSizes
          },
          fontFamily: {
            options: fontFamilies
          },
          alignment:{
            options: [ 'left', 'center', 'right', 'justify' ]
          }

        }}
        onReady={editor => {
          // You can store the "editor" and use when it is needed.
          console.log('Editor is ready to use!', editor);
      
        }}

        onChange={(event, editor) => {
          const data = editor?.getData().replace(/data-mathml="/g, 'xmlns="') ;
          console.log({ event, editor, data });
          
          if(data.length){
            const plainText = data.replace(/<[^>]*>/g,'');
            this.props.handleChange && this.props.handleChange(data, plainText);
            this.setState({ html: data });
            window.navigator.clipboard.writeText(data)
          }
        }}
        onBlur={(event, editor) => {
          console.log('Blur.', editor);
        }}
        onFocus={(event, editor) => {
          console.log('Focus.', editor);
        }}
      />

    </span>
  }
}


//fontSizes

let fontSizes = []

for (let i = 8; i <= 36; i++) {
  if (i === 16) fontSizes.push('default')
  else fontSizes.push(`${i}pt`)
}
